<template>
    <div class="card-blue card-body">
        <h6 class="card-title mt-3 mb-4">{{name}}</h6>
        <div class="table-responsive" style="clear: both;">
            <table class="table table-bordered table-sm">
                <thead class="text-center">
                <tr>
                    <th scope="col">Particulars</th>
                    <th scope="col">As on {{report.year_ending_date | date}}</th>
                    <th scope="col" v-if="previous_year_report">As on {{previous_year_report.year_ending_date |
                        date}}
                    </th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(field, index1) in input_fields">
                    <tr>
                        <template v-if="field.type !== 'json'">
                            <td>{{field.label}}</td>
                            <td>{{report[id][field.db]}}</td>
                            <td v-if="previous_year_report">{{previous_year_report[id][field.db]}}</td>
                        </template>
                        <template v-else>
                            <td class="font-weight-bold">{{field.label}}</td>
                            <td></td>
                            <td v-if="previous_year_report"></td>
                        </template>
                    </tr>
                    <template v-for="(sub_field, index2) in field.fields">
                        <tr>
                            <template v-if="sub_field.type !== 'json'">
                                <td class="custom-pl-1">{{sub_field.label}}</td>
                                <td>{{report[id][field.db][sub_field.db]}}</td>
                                <td v-if="previous_year_report">
                                    {{previous_year_report[id][field.db][sub_field.db]}}
                                </td>
                            </template>
                            <template v-else>
                                <td class="font-weight-bold custom-pl-1">{{sub_field.label}}</td>
                                <td></td>
                                <td v-if="previous_year_report"></td>
                            </template>
                        </tr>
                        <template v-for="(sub_sub_field, index3) in sub_field.fields">
                            <tr>
                                <template v-if="sub_sub_field.type !== 'json'">
                                    <td class="custom-pl-2">{{sub_sub_field.label}}</td>
                                    <td>{{report[id][field.db][sub_field.db][sub_sub_field.db]}}</td>
                                    <td v-if="previous_year_report">
                                        {{previous_year_report[id][field.db][sub_field.db][sub_sub_field.db]}}
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="custom-pl-2">{{sub_sub_field.label}}</td>
                                    <td></td>
                                    <td v-if="previous_year_report"></td>
                                </template>
                            </tr>
                            <template v-for="(sub_sub_sub_field, index3) in sub_sub_field.fields">
                                <tr>
                                    <template v-if="sub_sub_sub_field.type !== 'json'">
                                        <td class="custom-pl-3">{{sub_sub_sub_field.label}}</td>
                                        <td>
                                            {{report[id][field.db][sub_field.db][sub_sub_field.db][sub_sub_sub_field.db]}}
                                        </td>
                                        <td v-if="previous_year_report">
                                            {{previous_year_report[id][field.db][sub_field.db][sub_sub_field.db][sub_sub_sub_field.db]}}
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td class="custom-pl-3">{{sub_sub_sub_field.label}}</td>
                                        <td></td>
                                        <td v-if="previous_year_report"></td>
                                    </template>
                                </tr>
                            </template>
                        </template>
                    </template>
                </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PrintFinancialReport",
        props: ["name", "id", "input_fields", "report", "events", "previous_year_report"],
    }
</script>

<style scoped>
    .custom-pl-1 {
        padding-left: 2rem !important;
    }

    .custom-pl-2 {
        padding-left: 4rem !important;
    }

    .custom-pl-3 {
        padding-left: 6rem !important;
    }

    .custom-pl-4 {
        padding-left: 8rem !important;
    }

    .badge {
        font-weight: 700;
        vertical-align: top;
        font-size: 10px;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
        padding: 4px 5px 4px;
        display: inline-block;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        border-radius: 3px;
        color: #fff;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }
</style>
